import { axios } from '../../services/axios';

export default async function updateVendorDefinedStatus(serviceID, statusID) {
    return axios
        .put(`/Service/VendorDefined/${serviceID}/Status/${statusID}`, null)
        .then((res) => res.data)
        .catch((e) => e);
}
